import { Component } from '@angular/core';
import { BaseComponent } from '../../base-component/base.component';

@Component({
  selector: 'favie-page-layout',
  templateUrl: './page-layout.component.html',
})
export class PageLayoutComponent extends BaseComponent {}
